var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      class: { open: _vm.menu.isOpen || _vm.menu.hoverActive },
      attrs: { id: "sidebar" },
    },
    [
      _c("div", { staticClass: "content" }, [
        _vm.permissions.length || _vm.isAdmin
          ? _c(
              "div",
              {
                key: "menu-" + _vm.forceRenderCount,
                ref: "scrollRef",
                staticClass: "menu-list",
                on: {
                  mouseenter: _vm.mouseEnterStart,
                  mouseleave: _vm.mouseLeaveStart,
                },
              },
              [
                _vm._l(_vm.allowedRoutes(), function (item) {
                  return [
                    _c(
                      "a-tooltip",
                      {
                        key: item.key,
                        attrs: {
                          title: item.title,
                          placement: "right",
                          overlayClassName:
                            _vm.menu.isOpen || _vm.menu.hoverActive
                              ? " hiddenToolTip"
                              : "",
                        },
                        on: { click: _vm.closeMenu },
                      },
                      [
                        _c(
                          "router-link",
                          {
                            staticClass: "menu-list-item",
                            attrs: { to: item.path },
                          },
                          [
                            _c(
                              "div",
                              { staticClass: "menu-list-item-icon" },
                              [
                                item.isNew
                                  ? _c("div", { staticClass: "new-tag" }, [
                                      _vm._v("NEW"),
                                    ])
                                  : _vm._e(),
                                _vm._v(" "),
                                item.antIcon
                                  ? _c("a-icon", {
                                      staticStyle: { "font-size": "20px" },
                                      style: {
                                        color: _vm.bugExist
                                          ? "red !important"
                                          : "#9ba2b6 !important",
                                      },
                                      attrs: { type: item.antIcon },
                                    })
                                  : _c(item.icon, {
                                      tag: "component",
                                      staticClass: "myIcon",
                                    }),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c("div", { staticClass: "menu-list-item-title" }, [
                              _vm._v(_vm._s(item.title)),
                            ]),
                          ]
                        ),
                      ],
                      1
                    ),
                  ]
                }),
              ],
              2
            )
          : _vm._e(),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "dropdown-control", on: { click: _vm.clickItem } },
          [
            _c("div", { staticClass: "information-text" }, [
              _vm._v(_vm._s(_vm.$t("message.showHide"))),
            ]),
            _vm._v(" "),
            _c("div", [
              _c("div", { staticClass: "material-icons" }, [
                _vm._v(
                  "\n                    " +
                    _vm._s(
                      _vm.menu.isOpen || _vm.menu.hoverActive
                        ? "chevron_left"
                        : "chevron_right"
                    ) +
                    "\n                "
                ),
              ]),
            ]),
          ]
        ),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }